





































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { HToOpacity } from '@/utils/tool'
import toB2cUrl from '@/utils/toB2cUrl'

interface styleType {
  width: string | number,
  height: string | number,
  background: string,
  border: string,
  borderRadius: string | number,
  boxShadow: string
}

@Component({
  name: 'Card'
})
export default class Card extends Vue {
  /**
   * @param {boolean} loading 加载状态
   * @description: 默认 false
   */
  @Prop({
    default: false,
    type: Boolean
  }) loading!: boolean

  /**
   * @param {number | string} width 卡片宽
   * @description: 默认380 最大 100%
   */
  @Prop({
    default: 380,
    type: [Number, String]
  }) width!: number | string

  /**
   * @param {number | string} height 卡片高
   * @description: 默认356
   */
  @Prop({
    default: 356,
    type: [Number, String]
  }) height!: number | string

  /**
   * @param {string} background 卡片背景样式
   * @description: 默认 #FFFFFF
   */
  @Prop({
    default: '#FFFFFF',
    type: String
  }) background!: string

  /**
   * @param {string} TopBackground 卡片顶部 背景样式
   * @description: 默认 #FFFFFF
   */
  @Prop({
    default: () => ({}),
    type: Object
  }) TopBackground!: any

  /**
   * @param {number} border 边框宽度
   * @description: 默认1px
   */
  @Prop({
    default: 1,
    type: Number
  }) border!: number

  /**
   * @param {string} borderType 边框类型
   * @description: 默认solid
   */
  @Prop({
    default: 'solid',
    type: String
  }) borderType!: string

  /**
   * @param {string} borderColor 边框颜色
   * @description: 默认#E5EBF5
   */
  @Prop({
    default: '#E5EBF5',
    type: String
  }) borderColor!: string

  /**
   * @param {number | string} radius 圆角
   * @description: 默认15
   */
  @Prop({
    default: 15,
    type: [Number, String]
  }) radius!: number | string

  /**
   * @param {string} shadow 卡片边框阴影
   * @description: 默认 0px 4px 8px 0px rgba(31, 37, 51, 0.04)
   */
  @Prop({
    default: '0px 4px 4px 3px rgba(31, 37, 51, 0.04)',
    type: String
  }) shadow!: string

  /**
   * @param {string} title 卡片标题
   * @description: 默认空
   */
  @Prop({
    type: String
  }) title!: string

  /**
   * @param {string} title 卡片标题颜色 16进制
   * @description: 默认 #00A5FE
   */
  @Prop({
    type: String,
    default: '#00A5FE'
  }) titleColor!: string

  /**
   * @param {string} title 卡片标题字体大小
   * @description: 默认 30px
   */
  @Prop({
    type: String,
    default: '30px'
  }) titleSize!: string

  /**
   * @param {string} icon 卡片标题 icon
   * @description: 默认空
   */
  @Prop({
    type: String
  }) icon!: string

  /**
   * @param {string} list 数组数据
   * @description: 默认空数组
   */
  @Prop({
    type: Array,
    default: () => ([
      {
        title: '爆款返场（限购3天）I地铁直达爆款返场（限购3天）I地铁直达'
      },
      {
        title: '爆款返场（限购3天）I地铁直达爆款返场（限购3天）I地铁直达'
      },
      {
        title: '爆款返场（限购3天）I地铁直达爆款返场（限购3天）I地铁直达'
      },
      {
        title: '爆款返场（限购3天）I地铁直达爆款返场（限购3天）I地铁直达'
      },
      {
        title: '爆款返场（限购3天）I地铁直达爆款返场（限购3天）I地铁直达'
      }
    ])
  }) list!: Array<any>

  // 卡片样式
  get styleTypes (): styleType {
    const w = typeof this.width === 'number' ? this.width + 'px' : this.width
    const h = typeof this.height === 'number' ? this.height + 'px' : this.height
    const r = typeof this.radius === 'number' ? this.radius + 'px' : this.radius
    return {
      width: w,
      height: h,
      background: this.background,
      border: `${this.border + 'px'} ${this.borderType} ${this.borderColor}`,
      borderRadius: r,
      boxShadow: this.shadow
    }
  }

  // 16进制颜色加透明度 100 为不透明 0 为全透明
  HToOpacity = HToOpacity

  @Emit('more')
  clickMore () {
    return ''
  }

  clickTitle (item, e): void {
    // console.log(e)
    toB2cUrl(item, e.screenX, e.screenY)
  }
}
